import { Injectable } from '@angular/core';
import csrJSON from '../data/CSR.json'
import { CSR } from '../models/csr';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CsrService {

  constructor(private httpService: HttpClient) { }
  csrListing(){
    // return csrJSON as CSR[]
    return this.httpService.get('https://www.calpinetech.com/data/CSR.json');
  }
}
